import { computed } from "vue";
import { usePublicReviewStore } from "../stores";
export function usePublicReview() {
    const store = usePublicReviewStore();
    return {
        reviewContext: computed(() => store.reviewContext),
        pageState: computed(() => store.pageState),
        isLoadingReview: computed(() => store.isLoadingReview),
        isSubmittingReview: computed(() => store.isSubmittingReview),
        reviewError: computed(() => store.reviewError),
        loadReviewContext: (invitationId, accessGrant) => store.loadReviewContext(invitationId, accessGrant),
        submitReview: (invitationId, accessGrant, data) => store.submitReview(invitationId, accessGrant, data),
    };
}
